import { render, staticRenderFns } from "./AfterSaleServiceAppointment.vue?vue&type=template&id=27c7ffe6&scoped=true&"
import script from "./AfterSaleServiceAppointment.vue?vue&type=script&lang=js&"
export * from "./AfterSaleServiceAppointment.vue?vue&type=script&lang=js&"
import style0 from "./AfterSaleServiceAppointment.vue?vue&type=style&index=0&id=27c7ffe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7ffe6",
  null
  
)

export default component.exports